import { useCallback } from "react";
import { axiosV2 } from "../candidates/axios";

export interface IPostSanctionEventParams {
  idConsequenceSanction: string;
}

export const SanctionEventDecision = {
  VALIDATION: "VALIDATION",
  REFUSAL: "REFUS",
} as const;

export type TSanctionEventDecision = (typeof SanctionEventDecision)[keyof typeof SanctionEventDecision];

export interface IPostSanctionEventBody {
  decision?: TSanctionEventDecision;
  montantValide?: number;
  dureeValidee?: number;
  justificationDecisionSanction?: string;
}

export const usePostSanctionEvent = () => {
  const [state, execute, cancel] = axiosV2<null>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IPostSanctionEventBody, consequenceId: string) =>
      execute({
        url: `/candidates/sanctions/${consequenceId}/event`,
        data,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
